import { memo } from "react";
import { CardHeader } from "../../CardHeader";
import { useTablePropsContext } from "../context";

export const Header = memo(() => {
  const tableProps = useTablePropsContext();

  if (!tableProps?.headerProps) {
    return null;
  }

  return (
    <CardHeader
      divider
      {...tableProps?.headerProps}
    />
  );
});